import { createSubscriptionHandshakeLink } from "aws-appsync-subscription-link";
import { createAuthLink } from "aws-appsync-auth-link";
import appSyncConfig from "../config/aws-exports";
import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink,
} from "@apollo/client";

/* The HTTPS endpoint of the AWS AppSync API 
  (e.g. *https://aaaaaaaaaaaaaaaaaaaaaaaaaa.appsync-api.us-east-1.amazonaws.com/graphql*). 
  [Custom domain names](https://docs.aws.amazon.com/appsync/latest/devguide/custom-domain-name.html) can also be supplied here (e.g. *https://api.yourdomain.com/graphql*). 
  Custom domain names can have any format, but must end with `/graphql` 
  (see https://graphql.org/learn/serving-over-http/#uris-routes). */
const url = appSyncConfig.aws_appsync_graphqlEndpoint;

const region = appSyncConfig.aws_appsync_region;

// Determine if we're connecting to a local development server
const isLocalDevelopment =
  url.includes("localhost") || url.includes("127.0.0.1");

const auth = isLocalDevelopment
  ? {
      type: "API_KEY" as const,
      apiKey: "local-dev-key",
    }
  : {
      type: "AMAZON_COGNITO_USER_POOLS" as const,
      jwtToken: async () => "", // Required when you use Cognito UserPools OR OpenID Connect. token object is obtained previously
    };

const httpLink = new HttpLink({ uri: url });

// For AWS AppSync endpoints, use AppSync authentication
// For local development, use standard HTTP link
const link = isLocalDevelopment
  ? httpLink
  : ApolloLink.from([
      createAuthLink({ url, region, auth }),
      createSubscriptionHandshakeLink({ url, region, auth }, httpLink),
    ]);

const defaultOptions = {
  watchQuery: {
    fetchPolicy: "no-cache" as const,
    errorPolicy: "ignore" as const,
  },
  query: {
    fetchPolicy: "no-cache" as const,
    errorPolicy: "all" as const,
  },
};

export const apolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache({
    addTypename: false,
  }),
  defaultOptions: defaultOptions,
});

export default apolloClient;
